module.exports = __webpack_public_path__ + "static/media/subtitle_badge.4c306234.svg";